import { DefaultTheme } from 'styled-components'
/**
 * @deprecated
 * @see colours
 */
const palette = {
  buttonGrey: '#dddddd',
  buttonGreyHover: '#e8e8e8',
  red: '#ff3366',
  lightred: '#ff6583',
  black: '#333333',
  white: '#ffffff',
  pink: '#ff6699',
  lightpink: '#ff85ae',
  palerose: '#ffdbea',
  green: '#82d893',
  successgreen: '#3fe3c9',
  lightsuccessgreen: '#77ebd9',
  turquoise: '#9dd5c0',
  hoverblue: '#ebf5ff',
  lightblue: '#bcdef0',
  rockblue: '#a0bed1',
  blue: '#9accea',
  darkblue: '#6d92eb',
  informationblue: '#2eb9ff',
  informationbluelight: '#60CAFF',
  lightgrey: '#eaeaea',
  grey: '#c1c1c1',
  silver: '#999999',
  darkgrey: '#787474',
  orange: '#fba423',
  lightorange: '#ffd295',
  purple: '#9966fb',
  darkpurple: '#330066',
  lightpurple: '#b8a6c9',
  delugepurple: '#8268a7',
  mulberry: '#c34f8b',
  lavender: '#c0b2d3',
  parchment: '#faf8e5',
  background: '#f5f4f7',
  yellow: '#ffd15c',
}

export const colours = {
  status: {
    primary: '#1890FF',
    secondary: '#EFEEFF',
    success: '#37A598',
    warning: '#DE7C12',
    danger: '#E01E4E',
    popout: '#FF5887',
  },
  category: {
    foodAndDrink: '#FF6699',
    clinicalCare: '#2EB9FF',
    healthRecords: '#9966FB',
    personalCare: '#82D893',
    activitiesAndSocial: '#FF9900',
    healthVisit: '#22D3B6',
    handover: '#6D92EB',
    incident: '#FF3366',
  },
  background: {
    primary: '#330066',
    secondary: '#704D94',
    tertiary: '#F5F4F7',
    quarternary: '#B8A6A9',
    table: '#E9ECEF',
  },
  neutral: {
    color1: '#000000',
    color2: '#1F1F1F',
    color3: '#333333',
    color4: '#595959',
    color5: '#999999',
    color6: '#BFBFBF',
    color7: '#D9D9D9',
    color8: '#F0F0F0',
    color9: '#F5F5F5',
    color10: '#FAFAFA',
    color11: '#FFFFFF',
  },
  hover: {
    primary: '#40A9FF',
    danger: '#FC668B',
    popout: '#FC92AC',
  },
  press: {
    primary: '#096DD9',
    danger: '#B90C37',
    popout: '#DC3967',
  },
}

const SMALL_RESOLUTION_MAX_WIDTH = 720
const MEDIUM_RESOLUTION_MAX_WIDTH = 1024

export type Shade<Category extends keyof Colours> = Colours[Category]
export type Shades = Shade<Categories>

export type Categories = keyof Colours

export type Colours = typeof colours

export const theme: DefaultTheme = {
  palette,
  color: colours,
  properties: {
    borderRadius: {
      small: '8px',
      medium: '16px',
      large: '24px',
    },
    zIndex: {
      basic: 0,
      modal: 1000,
      overlay: 2000,
      loader: 5000,
    },
  },
  mediaQueries: {
    mobileDown: `@media only screen and (max-width: ${SMALL_RESOLUTION_MAX_WIDTH}px)`,
    tabletUp: `@media only screen and (min-width: ${SMALL_RESOLUTION_MAX_WIDTH}px)`,
    tabletDown: `@media only screen and (max-width: ${MEDIUM_RESOLUTION_MAX_WIDTH}px)`,
  },
  font: {
    family: {
      mono: 'Menlo, Monaco, Consolas, "Courier New", monospace',
      sansSerif: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      serif: 'Georgia, Times New Roman, Times, serif',
    },
    weight: {
      bold: 700,
      medium: 500,
      regular: 400,
    },
  },
}
